import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import GroupTableData from "../Components/GroupTableData";
import Dashboard from "../pages/dashboard/Dashboard";
import UserDetail from "../pages/users/UserDetail";
import UserEdit from "../pages/users/UserEdit";
import UserList from "../pages/users/UserList";
import GroupDetail from "../pages/groups/GroupDetail";
import GroupEdit from "../pages/groups/GroupEdit";
import ChangePassword from "../pages/auth/ChangePassword";
import Login from "../pages/auth/Login";
import AppPurchase from "../pages/apppurchase/AppPurchase";
import Error from "../pages/error/Error";
import { VerifyUser } from "../pages/auth/VerifyUser";
import Maincontainer from "./Maincontainer";
import UserStatList from "../pages/users/UserStatList";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";
import GroupTable from "../pages/groups/GroupTable";
// import FAQs from "../TextEditor/FAQs";
import FAQs from "../Components/FAQs";
import Termandcondition from "../TextEditor/TermandConditionEditor";
import PrivacyPolicy from "../TextEditor/PrivacyPolicy";
import GroupStatTable from "../pages/groups/GroupStatTable";
import { Terms } from "../pages/terms/Terms";
import { Privacy } from "../pages/privacy/Privacy";
import { AboutPage } from "../pages/about/Aboutus";
import { Verify } from "../pages/Verify";


const Router = () => {
  return (
    <BrowserRouter basename="/admin">
      <Routes>
        <Route path="/" element={<Maincontainer />}>
          <Route index element={<Dashboard />} />
          <Route path="/edituser/:id" element={<UserEdit />} />
          <Route path="/userdetail/:id" element={<UserDetail />} />
          <Route path="/users" element={<UserList />} />
          <Route path="/userstats" element={<UserStatList />} />
          <Route path="/groups" element={<GroupTable />} />
          <Route path="/groupstats" element={<GroupStatTable />} />
          <Route path="/groupdetail/:id" element={<GroupDetail />} />
          <Route path="/editgroup/:id" element={<GroupEdit />} />
          <Route path="/changepassword" element={<ChangePassword />} />
          <Route path="/apppurchase" element={<AppPurchase />} />
          <Route path="/faqs" element={<FAQs />} />
          {/* <Route path="/aboutview" element={<AboutView />} /> */}
          <Route path="/term&condition" element={<Termandcondition />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        </Route>
        <Route path="/termview" element={<Terms />} />
        <Route path="/aboutusview" element={<AboutPage />} />
        <Route path="/privacyview" element={<Privacy />} />
        <Route path="/verify-account/:tokenId" element={<VerifyUser />} />
        <Route path="*" element={<Error />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/resetpassword/:tokenId" element={<ResetPassword />} />
        <Route path="/verify/:activityId/:oldParticipant/:type/:id/:token" element={<Verify />} />
        <Route path="/verify/:type/:id/:token" element={<Verify />} />

      </Routes>
    </BrowserRouter>
  );
};

export default Router;
